import {twMerge} from '../../../common/twMerge';
import {ButtonTabProps} from './ButtonTabProps.interface';

export function ButtonTab({
  className,
  children,
  onClick,
  ...props
}: ButtonTabProps) {
  return (
    <button
      className={twMerge(
        'font-small2 relative rounded-full border border-solid border-theme-transparent-20 px-10pxr text-theme-solid-100',
        className
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}
